import { useEffect, useState, type ReactNode } from 'react';
import { motion } from 'motion/react';
import { usePrefs } from './prefs';
import { Mascot } from './Mascot';

/** Same lines as the instant loading screen in index.html / public/boot.js. */
const TIPS = ['Blowing up the balloons…', 'Shuffling the grudges…', 'Warming up the buzzers…', 'Hiding the secret objectives…', 'Polishing the trophies…', 'Teaching the AI players to trash-talk…'];

/**
 * Loading screen used inside the app (a game loading, reconnecting, the TV connecting): Pop bouncing,
 * a moving bar and a rotating line. Pass `label` to say what is happening; it replaces the jokes.
 */
export function LoadingScreen({ label, big, children }: { label?: string; big?: boolean; children?: ReactNode }) {
  const { reducedMotion } = usePrefs();
  const [tip, setTip] = useState(0);
  useEffect(() => {
    if (label) return;
    const t = setInterval(() => setTip((i) => (i + 1) % TIPS.length), 1800);
    return () => clearInterval(t);
  }, [label]);
  return (
    <div className="flex-1 grid place-items-center text-center p-6" role="status" aria-live="polite" data-testid="loading-screen">
      <div className="flex flex-col items-center gap-4">
        <Mascot size={big ? 260 : 170} />
        <div className={`rounded-full bg-white/10 overflow-hidden ${big ? 'w-96 h-4' : 'w-64 h-3'}`} aria-hidden>
          <motion.i
            className="block h-full w-2/5 rounded-full bg-gradient-to-r from-[#ff3d7f] via-[#ffd23f] to-[#00e5ff]"
            animate={reducedMotion ? undefined : { x: ['-110%', '260%'] }}
            transition={{ duration: 1.3, repeat: Infinity, ease: 'easeInOut' }}
          />
        </div>
        <p className={`text-mute min-h-[2.6em] max-w-[30ch] ${big ? 'text-2xl' : 'text-base'}`}>{label ?? TIPS[tip]}</p>
        {children}
      </div>
    </div>
  );
}
